"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streams API
 * Manage Tapis Streams API.
 *
 * The version of the OpenAPI document: 1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var NewRoleResourceTypeEnum;
(function (NewRoleResourceTypeEnum) {
    NewRoleResourceTypeEnum["Project"] = "project";
    NewRoleResourceTypeEnum["Channel"] = "channel";
    NewRoleResourceTypeEnum["Template"] = "template";
})(NewRoleResourceTypeEnum = exports.NewRoleResourceTypeEnum || (exports.NewRoleResourceTypeEnum = {})); /**
* @export
* @enum {string}
*/
var NewRoleRoleNameEnum;
(function (NewRoleRoleNameEnum) {
    NewRoleRoleNameEnum["Admin"] = "admin";
    NewRoleRoleNameEnum["Manager"] = "manager";
    NewRoleRoleNameEnum["User"] = "user";
})(NewRoleRoleNameEnum = exports.NewRoleRoleNameEnum || (exports.NewRoleRoleNameEnum = {}));
function NewRoleFromJSON(json) {
    return NewRoleFromJSONTyped(json, false);
}
exports.NewRoleFromJSON = NewRoleFromJSON;
function NewRoleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !runtime_1.exists(json, 'user') ? undefined : json['user'],
        'resource_id': !runtime_1.exists(json, 'resource_id') ? undefined : json['resource_id'],
        'resource_type': !runtime_1.exists(json, 'resource_type') ? undefined : json['resource_type'],
        'role_name': !runtime_1.exists(json, 'role_name') ? undefined : json['role_name'],
    };
}
exports.NewRoleFromJSONTyped = NewRoleFromJSONTyped;
function NewRoleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': value.user,
        'resource_id': value.resource_id,
        'resource_type': value.resource_type,
        'role_name': value.role_name,
    };
}
exports.NewRoleToJSON = NewRoleToJSON;
